export default __webpack_public_path__ + "static/media/innovative-futuristic-classroom-students 1.f4d226e5.png";